<template>
    <div class="modal fade" :id="'editNode_' + node.imei" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Node Edit</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form method="POST">
                <div class="modal-body">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="active" id="active">
                        <label class="form-check-label" for="active">
                            Active
                        </label>
                    </div>
                    <hr/>
                    <div class="form-check" style="text-align: left;">
                        <label style="text-align: left;">Altitude (m) <input v-model="altitude_in_m" type="number" value="" pattern="/^\d*(\.\d{0,2})?$"  /></label>
                        <button v-on:click="clear_altitude">C</button>
                    </div>
                    <input id="name" type="text" class="form-control" name="fname" placeholder="Name" v-model="nodeName">
                    <input id="imei" type="text" class="form-control" name="fname" placeholder="imei" :value="node.imei"  disabled>
                    <input id="lat" type="text" class="form-control" name="fname" placeholder="lat"  v-model="lat">
                    <input id="lang" type="text" class="form-control" name="fname" placeholder="lng"  v-model="lng">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="has_snow" id="has_snow">
                        <label class="form-check-label" for="has_snow">
                            Has Snow
                        </label>
                    </div>
                    <div v-for="image_file in image">
                        <button type="button" v-on:click="clearImage(image_file)">clear image</button>
                        <img v-bind:src="'/images/all/'+image_file+'?'+Math.floor(Math.random() * 9999999)"  width="50" height="50" />
                    </div>
                    <div v-if="image.length < 2">
                        <label class="form-label" for="customFile">Upload Image</label>
                        <input type="file" class="form-control" accept="image/png" v-on:change="uploadImage" />
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="editNode">Save changes</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import {bus} from "../app";

export default {
    props: [ 'node' ],
    data() {
        return {
            nodeName: this.node.name,
            lat: this.node.lat,
            lng: this.node.lng,
            active: this.node.active,
            altitude_in_m: this.node.altitude_in_m,
            has_snow: this.node.has_snow,
            image: this.node.image
        }
    },
    methods: {
        clearImage(image_file){
            this.axios.post(
                '/image/clear',
                {
                    'imei':this.node.imei,
                    'image':image_file
                },
            ).then(
                response => {
                    this.image = response.data.image
                }
            )
        },
        uploadImage(event) {
            let self = this;
            const URL = 'image/upload';

            let data = new FormData();
            data.append('file', event.target.files[0]);
            data.append('imei', this.node.imei)
            data.append('has_snow', this.node.has_snow)

            let config = {
                header : {
                    'Content-Type' : 'image/png'
                }
            }

            self.axios.post(
                URL,
                data,
                config
            ).then(
                response => {
                    self.image = response.data.image
                }
            )
        },
        editNode() {
            let self = this;
            self.axios
                .post('/node-update',
                { imei : this.node.imei,
                        name : this.nodeName,
                        lat : this.lat,
                        lng : this.lng,
                        altitude_in_cm : this.altitude_in_m!==null?(this.altitude_in_m * 100):null,
                        active : this.active,
                        has_snow: this.has_snow
                     })
                .then(response => {
                    self.close()
                })
        },
        clear_altitude:function(e){
            e.preventDefault();
            this.altitude_in_m = null
        },
        close:function (){
            $('#editNode_'+this.node.imei).modal('hide');
            bus.$emit('modal_closed',true)
        },
    }
}
</script>
